import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { reduxForm, Field } from 'redux-form';
import { TextField, SelectField } from 'redux-form-material-ui';
import MenuItem from 'material-ui/MenuItem';
import RaisedButton from 'material-ui/RaisedButton';
import _ from 'lodash';

class AssignTracker extends Component {
  static propTypes = {
    handleSubmit: PropTypes.func.isRequired,
    submitting: PropTypes.bool.isRequired,
  }
  static validate = (values) => {
    const errors = {};
    const requiredFields = ['id', 'type'];

    requiredFields.forEach((item) => {
      if (!values[item]) {
        errors[item] = 'Required';
      }
    });
    
    return errors;
  }

  renderTextField = props => {
    const { initValue, ...newProps } = props;
    return (<TextField hintText={props.label} floatingLabelText={props.label} errorText={props.touched && props.error} {...newProps} value={initValue} />);
  };


  render() {
    const { handleSubmit, submitting } = this.props;
    
    const buttonText = (submitting) ? 'Saving...' : 'Assign Tracker';
    return (
      <form onSubmit={handleSubmit}>
        <div className="row">
          <div className="col s12 m6">
            <Field name="type" type="text" component={SelectField} floatingLabelText="Type" fullWidth>
              <MenuItem value="trailer" primaryText="Trailer" />
              <MenuItem value="truck" primaryText="Unit" />
            </Field>
          </div>
          <div className="col s12 m6">
            <Field name="id" type="text" component={this.renderTextField} floatingLabelText="Identifier" fullWidth />
          </div>
        </div>
        <div className="row">
          <div className="col s12 m8"></div>
          <div className="col s12 m4">
            <RaisedButton onClick={handleSubmit} fullWidth primary style={{color:'#fff'}}>{buttonText}</RaisedButton>
          </div>
        </div>
      </form>
    );
  }
}

export default reduxForm({
  form: 'assignTrackerForm',
  validate: AssignTracker.validate
})(AssignTracker);





// WEBPACK FOOTER //
// ./src/components/Fleet/Trackers/Assign.js